
	var hoursGet = document.querySelector('#jHoursGet');
	var hoursMore = document.querySelector('.jHoursMore');

	function closeHours() {
		hoursGet.classList.remove('open');
	}  

	hoursGet.addEventListener('click', function(e) {
		this.classList.toggle('open');
		e.stopPropagation();
	});

	//   close menus when clicking outside of them
	window.addEventListener('click', function(event) {
		if (event.target != hoursGet) {
			// Moved the code here to its own function.
			closeHours();
		}
	});
